













import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class WithSideNavigation extends Vue {
    @Prop({ type: Boolean, required: true })
    private hasLeftMenu!: boolean;

    @Prop({ type: Boolean, default: true })
    private enableContainer!: boolean;

    @Prop({ type: String, default: 'w-2/12' })
    private leftSideClass!: string;
}
